module.exports = __webpack_public_path__ + "static/media/user6.13988554.jpg";